import { Component, Input, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-collabo-portal-dxsales-updated-password',
  templateUrl: './collabo-portal-dxsales-updated-password.component.html',
  styleUrls: ['./collabo-portal-dxsales-updated-password.component.css',
    '../style/global.css',],
})
export class CollaboPortalDxSalesUpdatedPasswordComponent implements OnInit {
  @Input() clientId: string;
  constructor() { }

  ngOnInit(): void {
  }
  get dxSalesLink() {
    const app = environment.apps[this.clientId];
    return app?.dxSales?.updatedPasswordLink.dxSales || 'https://google.com';
  }
  get sgzpApp4Link() {
    const app = environment.apps[this.clientId];
    return app?.dxSales?.updatedPasswordLink.sgzpApp4 || 'https://google.com';
  }
  get sgzpApp6Link() {
    const app = environment.apps[this.clientId];
    return app?.dxSales?.updatedPasswordLink.sgzpApp6 || 'https://google.com';
  }
}
